interface MissionSectionProps {
  language: 'es' | 'en';
}

export default function MissionSection({ language }: MissionSectionProps) {
  const content = {
    es: {
      title: 'Nuestra Misión',
      message1: 'En First Step Japan creemos que todas las personas de habla hispana —ya sean de Latinoamérica, España o cualquier parte del mundo— merecen empezar su vida en Japón con claridad, confianza y compañía.',
      message2: 'Nuestro proyecto está dedicado a quienes hablan español, pero abierto a toda persona que busque sentirse acompañada en sus primeros pasos en Japón.'
    },
    en: {
      title: 'Our Mission',
      message1: 'At First Step Japan, we believe that all Spanish-speaking people, from Latin America, Spain, or anywhere in the world, deserve to start their new life in Japan with clarity, confidence, and support.',
      message2: 'Our project is dedicated to Spanish speakers, but open to anyone who wants to feel guided and welcomed in Japan.'
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-red-600 to-yellow-600 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 text-8xl">🌏</div>
        <div className="absolute bottom-20 right-20 text-6xl">🤝</div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-7xl">🇯🇵</div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            {content[language].title} 🌏
          </h2>
          
          <div className="space-y-8">
            <p className="text-xl md:text-2xl leading-relaxed font-light">
              {content[language].message1}
            </p>
            
            <p className="text-lg md:text-xl leading-relaxed opacity-90">
              {content[language].message2}
            </p>
          </div>

          {/* Decorative Elements */}
          <div className="flex justify-center items-center space-x-8 mt-12">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center text-3xl backdrop-blur-sm">
              🇪🇸
            </div>
            <div className="w-20 h-20 bg-white/30 rounded-full flex items-center justify-center text-4xl backdrop-blur-sm">
              🤝
            </div>
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center text-3xl backdrop-blur-sm">
              🇯🇵
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}